import AbstractView = require("./abstract/AbstractView");
import YTPlayer = require("../media/YTPlayer");
import GoogleAnalyticsService = require("../service/GoogleAnalyticsService");

class PlayerView extends AbstractView {


    private ytPlayer: YTPlayer;
    private $closeBtn: JQuery;
    private currentTracking: string;

    constructor(template: JQuery) {
        super(template);
    }

    reset(): void {
        if (this.ytPlayer) this.ytPlayer.stop();
    }

    init() {
        this.$closeBtn = this.$template.find(".closeBtn");
        this.$closeBtn.on("click tap", (eventObject: JQueryEventObject) => {
            eventObject.preventDefault();
            GoogleAnalyticsService.instance().sendTracking(
                'event',
                'videos',
                'stopped',
                this.currentTracking
            );
            this.transitionOut();
        });
        this.ytPlayer = new YTPlayer("ytPlayer", "", false, true, true);
        this.ytPlayer.emitter.on(YTPlayer.VideoEvent.ON_PLAYING, () => {
        });
        this.ytPlayer.emitter.on(YTPlayer.VideoEvent.ON_PAUSE, () => {
        });
    }

    public playVideo(id: string): void {
        this.ytPlayer.changeVideo(id);
        this.transitionIn();
    }

    public stopVideo(): void {
        this.transitionOut();
    }

    public set tracking(t: string) {
        this.currentTracking = t;
    }

}

export = PlayerView;